export type ApproverOptions =
  | { type: "sync"; syncId: string }
  | { type: "model"; modelId: string }
  | { type: "sync"; modelId: string; destinationId: string }
  | { type: "model"; sourceId: string };

// The ids frequently originate from GraphQL bigint columns, so at runtime they
// can be numbers despite the declared types. The reviewer queries declare their
// variables as String, and Hasura rejects forwarded numeric values with
// "String cannot represent a non string value", so coerce every id here.
export const formatSyncReviewersInput = (approverOptions: ApproverOptions) => {
  if (approverOptions.type !== "sync") {
    return {};
  }

  if ("syncId" in approverOptions) {
    return {
      syncId: approverOptions.syncId?.toString(),
    };
  }

  return {
    modelId: approverOptions.modelId?.toString(),
    destinationId: approverOptions.destinationId?.toString(),
  };
};

export const formatModelReviewersInput = (approverOptions: ApproverOptions) => {
  if (approverOptions.type !== "model") {
    return {};
  }

  if ("modelId" in approverOptions) {
    return { modelId: approverOptions.modelId?.toString() };
  }

  return { sourceId: approverOptions.sourceId?.toString() };
};
